import dayjs from "dayjs";

export const EMPTY_VALUE = "-";

export function isNumber(value) {
    return typeof value === "number" && Number.isFinite(value);
}

export function formatPriceNumber(value, precision = 2) {
    if (!isNumber(value)) {
        return EMPTY_VALUE;
    }

    return value.toFixed(precision);
}

export function formatCurrencyUnit(currency, unit) {
    const parts = [currency, unit].filter(Boolean);
    return parts.length ? parts.join("/") : EMPTY_VALUE;
}

export function formatPriceDisplay(value, options = {}) {
    const {
        currency,
        unit,
        precision = 2,
        withUnit = false,
    } = options;

    const formattedValue = formatPriceNumber(value, precision);
    if (formattedValue === EMPTY_VALUE) {
        return EMPTY_VALUE;
    }

    if (!withUnit) {
        return formattedValue;
    }

    return `${formattedValue} ${formatCurrencyUnit(currency, unit)}`;
}

export function formatSignedNumber(value, precision = 2) {
    if (!isNumber(value)) {
        return EMPTY_VALUE;
    }

    return `${value >= 0 ? "+" : ""}${value.toFixed(precision)}`;
}

export function formatSignedPercent(value, precision = 1) {
    if (!isNumber(value)) {
        return EMPTY_VALUE;
    }

    return `${value >= 0 ? "+" : ""}${value.toFixed(precision)}%`;
}

export function formatDateTime(value, pattern = "YYYY-MM-DD HH:mm:ss") {
    if (!value) {
        return EMPTY_VALUE;
    }

    return dayjs(value).format(pattern);
}

export function getDifferenceColor(value) {
    if (!isNumber(value) || value === 0) {
        return "inherit";
    }

    return value > 0 ? "#f5222d" : "#52c41a";
}
